import { LoginPage } from '../../components/pages/account/login'
export default LoginPage
